(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('asociarse', {
            parent: 'public',
            url: '/asociarse',
            data: {
                pageTitle: 'global.menu.asociarse'
            },
            views: {
                'content@': {
                    templateUrl: 'app/public/asociarse/asociarse.html'
                }
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/asociarse');
                }
            }
        });
    }
})();
